var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"list-map\"\u003E\u003Cdiv class=\"list-map__container\" ref=\"map\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./new-blocks/map/list/list-map.pug
// module id = ./new-blocks/map/list/list-map.pug
// module chunks = 0 2